import { Box, Breadcrumbs, Button, FormControl, FormLabel, Input, Stack, Typography } from "@mui/joy";
import LogoTitle from "../components/LogoTitle";
import { useNavigate } from "react-router";
import { useEffect } from "react";




export default function MainPage() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/lenta', { replace: true });
    }, [navigate]);

    return null; // или можно показать лоадер

    // return (
    //     <Box sx={{ display: 'flex' }}>
    //         <Box
    //             className="MainContent"
    //             sx={{
    //                 px: { xs: 2, md: 6 },
    //                 pt: 2,
    //                 pb: { xs: 2, sm: 2, md: 3 },
    //                 flex: 1,
    //                 display: 'flex',
    //                 flexDirection: 'column',
    //                 minWidth: 0,
    //                 height: '100dvh',
    //                 gap: 1,
    //             }}
    //         >
                
    //             <Box
    //                 sx={{
    //                     display: 'flex',
    //                     mb: 1,
    //                     gap: 1,
    //                     flexDirection: { xs: 'column', sm: 'row' },
    //                     alignItems: { xs: 'start', sm: 'center' },
    //                     flexWrap: 'wrap',
    //                     justifyContent: 'space-between',
    //                 }}
    //             >
    //                 <Stack direction={'row'} spacing={2} sx={{ alignItems: "center", justifyContent: "flex-start" }}>
    //                     <LogoTitle/>
    //                     <Typography level="h2" component="h1">
    //                         Главная
    //                     </Typography>
    //                 </Stack>
    //             </Box>


    //         </Box>
    //     </Box>
    // );
}